import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type AlertType = 'error' | 'success' | 'info' | 'warning';

@Component({
  selector: 'eg-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AlertComponent {
  @Input() message: string;
  @Input() type: AlertType = 'info';
  @Input() showImg: boolean;
}
